import React, { useEffect, useState } from "react";
import locationMapAuthHero from "../Assets/Images/locationMapAuthArtwork.jpg";
// import locationMapIntroHero from "../Assets/Images/locationMapIntroHero.jpg";
import anchorLogo from "../Assets/Images/anchorLogo.png";
import "./MapScanAuthModal.css";

export default function MapScanAuthModal({
  desktopPromoImage,
  desktopPromoMessage,
  errorMessage,
  isLoading,
  onSubmit,
  title = "Let's begin.",
  subtitle = "Enter your details to continue.",
}) {
  const [formData, setFormData] = useState({
    username: "",
  });
  const [isConsentChecked, setIsConsentChecked] = useState(true);
  const [activeScreen, setActiveScreen] = useState("intro");
  const [isDesktopViewport, setIsDesktopViewport] = useState(
    window.innerWidth > 960
  );

  useEffect(() => {
    const storedUsername =
      localStorage.getItem("actuality_map_scan_username") ||
      localStorage.getItem("actuality_map_scan_name") ||
      "";

    setFormData((current) => ({
      ...current,
      username: storedUsername,
    }));
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktopViewport(window.innerWidth > 960);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    localStorage.setItem("actuality_map_scan_username", formData.username);
    onSubmit(formData);
  };

  if (desktopPromoImage && isDesktopViewport) {
    return (
      <div className="map-scan-auth-desktop-promo">
        <img
          alt="Anchorball desktop landing artwork"
          className="map-scan-auth-desktop-promo-image"
          src={desktopPromoImage}
        />
        <div className="map-scan-auth-desktop-promo-overlay" />
        <div className="map-scan-auth-desktop-promo-copy">
          <p>{desktopPromoMessage || "For better experience open this link on your mobile."}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="map-scan-auth-page">
      <div className="map-scan-auth-shell">
        <div className="map-scan-auth-brandline">
          <span>ANCHORBALL</span>
          <span className="map-scan-auth-brand-dot" />
          <span>A CURIOUS ART JOURNEY</span>
        </div>
        <div className="map-scan-auth-phone">
          <section
            className={`map-scan-auth-screen${
              activeScreen === "form" ? " is-form" : ""
            }`}
          >
            {activeScreen === "intro" ? (
              <div className="map-scan-auth-splash">
                <img
                  alt="Anchorball splash artwork"
                  className="map-scan-auth-splash-image"
                  src={locationMapAuthHero}
                />
                <img
                  alt="Anchorball logo"
                  className="map-scan-auth-splash-image-anchor-logo"
                  src={anchorLogo}
                />
                <div className="map-scan-auth-splash-overlay" />
                <div className="map-scan-auth-splash-content">
                  <p className="map-scan-auth-splash-eyebrow">
                    Royal Botanical Gardens · Hendrie Park
                  </p>
                  <h1>
                    Hunt down all 17 sculptures of{" "}
                    <span>A Curious Art Journey.</span>
                  </h1>
                  <div className="map-scan-auth-chip-row">
                    <span className="map-scan-auth-chip">JUN 20 – SEP 20</span>
                    <span className="map-scan-auth-chip">17 SCULPTURES</span>
                    <span className="map-scan-auth-chip">AR + QR TRAIL</span>
                  </div>
                  <button
                    className="map-scan-auth-submit map-scan-auth-submit-accent"
                    onClick={() => setActiveScreen("form")}
                    type="button"
                  >
                    <span>START YOUR ADVENTURE</span>
                    <svg
                      aria-hidden="true"
                      height="18"
                      viewBox="0 0 24 24"
                      width="18"
                    >
                      <path d="M5 12h14M13 6l6 6-6 6" />
                    </svg>
                  </button>
                </div>
              </div>
            ) : (
              <>
                <div className="map-scan-auth-hero">
                  <img
                    alt="Scavenger hunt artwork"
                    className="map-scan-auth-hero-image"
                    src={locationMapAuthHero}
                  />
                  <img
                    alt="Anchorball logo"
                    className="map-scan-auth-hero-logo"
                    src={anchorLogo}
                  />
                  <div className="map-scan-auth-hero-veil" />
                </div>

                <div className="map-scan-auth-card">
                  <div className="map-scan-auth-handle" />
                  <p className="map-scan-auth-eyebrow">Map Access</p>
                  <h2>{title}</h2>
                  <p className="map-scan-auth-subtitle">{subtitle}</p>

                  <form className="map-scan-auth-form" onSubmit={handleSubmit}>
                    <div className="map-scan-auth-field">
                      <label htmlFor="actuality-map-auth-username">
                        Username
                      </label>
                      <div className="map-scan-auth-input-wrap">
                        <svg
                          aria-hidden="true"
                          height="18"
                          viewBox="0 0 24 24"
                          width="18"
                        >
                          <circle cx="12" cy="8" r="4" />
                          <path d="M4 21a8 8 0 0 1 16 0" />
                        </svg>
                        <input
                          id="actuality-map-auth-username"
                          name="username"
                          onChange={handleChange}
                          placeholder="curious_explorer"
                          required
                          type="text"
                          value={formData.username}
                        />
                      </div>
                    </div>

                    <button
                      className="map-scan-auth-consent"
                      onClick={() => setIsConsentChecked((current) => !current)}
                      type="button"
                    >
                      <span
                        className={`map-scan-auth-consent-box${
                          isConsentChecked ? " is-active" : ""
                        }`}
                      >
                        <svg
                          aria-hidden="true"
                          height="12"
                          viewBox="0 0 24 24"
                          width="12"
                        >
                          <path d="M20 6 9 17l-5-5" />
                        </svg>
                      </span>
                      <span>
                        Keep me posted on map updates and the next actuality scan
                        experience.
                      </span>
                    </button>

                    {errorMessage ? (
                      <p className="map-scan-auth-error">{errorMessage}</p>
                    ) : null}

                    <div className="map-scan-auth-spacer" />

                    <button
                      className="map-scan-auth-submit"
                      disabled={isLoading}
                      type="submit"
                    >
                      <span>
                        {isLoading ? "Opening..." : "START YOUR ADVENTURE"}
                      </span>
                      <svg
                        aria-hidden="true"
                        height="18"
                        viewBox="0 0 24 24"
                        width="18"
                      >
                        <path d="M5 12h14M13 6l6 6-6 6" />
                      </svg>
                    </button>
                  </form>
                </div>
              </>
            )}
          </section>
        </div>
      </div>
    </div>
  );
}
